import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-0"}],["path",{"d":"M3 7a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z","key":"svg-1"}],["path",{"d":"M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5","key":"svg-2"}],["path",{"d":"M7 8v.01","key":"svg-3"}],["path",{"d":"M7 16v.01","key":"svg-4"}]]

const IconServerSpark = createReactComponent('outline', 'server-spark', 'ServerSpark', __iconNode);

export default IconServerSpark;